// extracted by mini-css-extract-plugin
export var animationContainer = "_d6-0";
export var asteriskIcon = "_d6-8";
export var conversationLeftSection = "_d6-4";
export var conversationListItem = "_d6-3";
export var conversationMiddleSection = "_d6-5";
export var conversationRightSection = "_d6-6";
export var detailsContent = "_d6-1";
export var listContainer = "_d6-7";
export var modalContent = "_d6-2";